import { HandoffAction, PlayerAction, PossessionAction } from "../../../types";
import { ActionWithIntersection } from "../find-closest";
import { getDurationFromAction } from "../get-duration-from-action";
import { getActionIntersectionTime } from "./add-handoff";

export interface GetHandoffStartTimesProps {
  possessionIntersection: ActionWithIntersection<PossessionAction> | null;
  playerIntersection: ActionWithIntersection<PlayerAction> | null;
  handoff: HandoffAction;
}

export const getHandoffStartTimes = ({
  possessionIntersection,
  playerIntersection,
  handoff,
}: GetHandoffStartTimesProps) => {
  const handoffDuration = getDurationFromAction(handoff);

  // if intersect possession and player..
  if (possessionIntersection && playerIntersection) {
    const { action: possessionAction } = possessionIntersection;
    const possessionIntersectionTime = getActionIntersectionTime({
      action: possessionAction,
      pathPercentage: possessionIntersection.pathPercentage,
    });

    const { action: playerAction } = playerIntersection;
    const playerIntersectionTime = getActionIntersectionTime({
      action: playerAction,
      pathPercentage: playerIntersection.pathPercentage,
    });

    if (possessionIntersectionTime >= playerIntersectionTime) {
      return {
        possessionStartTime: possessionAction.startTime,
        playerStartTime:
          playerAction.startTime + possessionIntersectionTime - playerIntersectionTime + handoffDuration / 2,
        handoffStartTime: possessionIntersectionTime,
      };
    } else {
      return {
        playerStartTime: playerAction.startTime,
        possessionStartTime:
          possessionAction.startTime + playerIntersectionTime - possessionIntersectionTime - handoffDuration / 2,
        handoffStartTime: playerIntersectionTime - handoffDuration,
      };
    }
  }
  // else if only intersect possession..
  else if (possessionIntersection) {
    const possessionIntersectionTime = getActionIntersectionTime({
      action: possessionIntersection.action,
      pathPercentage: possessionIntersection.pathPercentage,
    });

    return {
      possessionStartTime: possessionIntersection.action.startTime,
      playerStartTime: 0,
      handoffStartTime: possessionIntersectionTime,
    };
  }
  // else if only intersect player..
  else if (playerIntersection) {
    const playerIntersectionTime = getActionIntersectionTime({
      action: playerIntersection.action,
      pathPercentage: playerIntersection.pathPercentage,
    });

    return {
      possessionStartTime: 0,
      playerStartTime: playerIntersection.action.startTime,
      handoffStartTime: playerIntersectionTime,
    };
  }
  // else if no intersection..
  else {
    return { possessionStartTime: 0, playerStartTime: 0, handoffStartTime: 0 };
  }
};
